export const MESSAGE_STATUSES = {
    ALERT: 'alert',
    MARKETING: 'marketing',
    SUPPORT: 'support',
}
